import { jsx as _jsx } from "react/jsx-runtime";
import { createElement, Fragment, memo, useCallback } from 'react';
import { useConfig } from '../hooks';
import { useComponent } from '../store/storeProvier';
import { useStoreApi } from '../store/storeProvier';
var Node = /*#__PURE__*/memo(function (_ref) {
  var id = _ref.id;
  var config = useComponent(id);

  var _useStoreApi = useStoreApi(),
      setState = _useStoreApi.setState,
      getState = _useStoreApi.getState;

  var _useConfig = useConfig(),
      components = _useConfig.components,
      onClick = _useConfig.onClick,
      onImpression = _useConfig.onImpression;

  var handleClick = useCallback(function (e) {
    Object.assign(e, {
      getState: getState,
      setState: setState
    });
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  }, [onClick, setState, getState]);

  var _ref2 = config || {},
      render = _ref2.render,
      childrens = _ref2.childrens;

  var component = components[render];
  return /*#__PURE__*/createElement(component || Fragment, component && Object.assign(Object.assign({}, config), {
    onClick: handleClick,
    onImpression: onImpression
  }), childrens === null || childrens === void 0 ? void 0 : childrens.map(function (childId) {
    return _jsx(Node, {
      id: childId
    }, childId);
  }));
});
Node.displayName = 'Node';
export default Node;